<div class="flex items-center compare-dropdown" *ngVar="loading$ | async as loading">
  <span class="mr-1 text-sm">Compare to</span>
  <ng-select
    id="compare-snapshot-dropdown"
    *ngVar="$any(snapshots$ | async) as snapshots"
    class="w-60 text-sm compare-dropdown"
    placeholder="Select a budget snapshot"
    [clearable]="true"
    [searchable]="false"
    bindValue="value"
    [loading]="loading"
    [formControl]="formControl"
    [items]="snapshots"
    [groupBy]="groupByFn"
    appendTo="body"
  >
    <ng-template ng-option-tmp let-item="item" let-index="index">
      <div>
        <div class="flex justify-between">
          <p
            class="w-40 overflow-hidden text-ellipsis"
            [attr.data-pendo-id]="
              item.snapshot_type === BUDGET_SNAPSHOT_USER_CREATED
                ? 'manual-snap-compare'
                : 'auto-snap-compare'
            "
            [auxTooltip]="item.label"
          >
            {{ item.label }}
          </p>
          <div class="flex items-center" *ngIf="item.value">
            <span
              *ngIf="item.snapshot_type === BUDGET_SNAPSHOT_USER_CREATED"
              inlineSVG="edit.svg"
              class="text-aux-blue mr-1"
              [setSVGAttributes]="{ class: 'w-3 h-3' }"
              (click)="editSnapshot($event, item)"
            ></span>
            <span
              inlineSVG="trash.svg"
              class="text-aux-red-dark"
              [setSVGAttributes]="{ class: 'w-4 h-4' }"
              (click)="deleteSnapshot($event, item)"
            ></span>
          </div>
        </div>
        <p class="text-aux-gray-darkest">{{ item.create_date | date: 'YYYY-MM-dd' }}</p>
      </div>
    </ng-template>
  </ng-select>
</div>
